import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
  name: "menu",
  initialState: {
    menus: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchMenus: (state) => {
      state.loading = true;
    },
    fetchMenusSuccess: (state, action) => {
      state.loading = false;
      state.menus = action.payload;
    },
    fetchMenusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchMenus, fetchMenusSuccess, fetchMenusFailure } =
  menuSlice.actions;

export default menuSlice.reducer;
